import React, { PropsWithChildren, useReducer } from "react"
import { BreadcrumbsContext } from "./context"
import { breadcrumbsReducer, initialBreadcrumbsState } from "./reducer"

export const BreadcrumbsContextProvider: React.FC<PropsWithChildren> = React.memo(({ children }) => {
	const [state, dispatch] = useReducer(breadcrumbsReducer, initialBreadcrumbsState)

	return <BreadcrumbsContext.Provider value={[state, dispatch]}>{children}</BreadcrumbsContext.Provider>
})
